import{jsxs as n,jsx as t}from"react/jsx-runtime";import d from"styled-components";import m from"../../theme.js";const h=d.div``,g=d.div`
  background: ${({theme:e,$customColor:o,$color:r="secondary",$colorShade:l})=>o||e.colors[r][l]};
  height: 0.25rem;
`,p=d.div`
  background: ${m.colors.background.light};

  ${({noFrame:e,topBorder:o,lineBorder:r,theme:l})=>!o&&(!e||r)&&`border-top: 1px solid ${l.colors.grayscaleToned.light5};`}

  ${({noFrame:e,lineBorder:o,theme:r})=>(!e||o)&&`border-bottom: 1px solid ${r.colors.grayscaleToned.light5};
  `}

  ${({noFrame:e,lineBorder:o,theme:r})=>!e&&!o&&`border-right: 1px solid ${r.colors.grayscaleToned.light5};
     border-left: 1px solid ${r.colors.grayscaleToned.light5};`}
`,a=({children:e,topBorder:o,topBorderColor:r,topBorderColorShade:l="mainAlt",noFrame:i=!1,lineBorder:s=!1,as:c="div"})=>n(h,{as:c,role:"region",children:[(o||r)&&t(g,{$customColor:o,$color:r,$colorShade:l}),t(p,{topBorder:o,noFrame:i,lineBorder:s,children:e})]});export{a as Card,a as default};
